<template>
    <div class="toolbox-footer" :style="getStyle">
        <!--
        Example of additional content in toolbox footer
          <button class="btn-icon icon-close"></button>
          <h3>Edit my GeoObject here :)</h3>
          <div class="formItem">
            <label>Input</label>
            <v-text-field solo flat hide-details class="sr-input" label="Name" placeholder="Enter name" value="Objekt im Zentrum von Wabern"></v-text-field>
          </div>
        -->
        <v-btn
                v-show="item.step >= 3"
                @click="save()"
                class="sr-button"
                text
                :loading="loading"
                :disabled="loading || !hasFileConfiguration || !item.objectRights"
        >
            Objekte importieren
        </v-btn>

        <v-btn
                v-show="item.step === 1 && item.getDropzone() && item.getDropzone().files.length >= 3"
                @click="item.step = 2"
                class="sr-button"
                text
                :loading="loading"
                :disabled="loading"
        >
            Weiter
        </v-btn>

        <queue-component @hasEntries="hasEntries = $event" v-if="item.step === 1"></queue-component>
    </div>
</template>

<script>
  import QueueComponent from '@/components/base/Queue'
  import _ from 'lodash'

  export default {
    props: {
      item: {
        type: Object,
        required: true
      },
      loading: {
        type: Boolean,
        default: false
      }
    },
    components: { QueueComponent },
    data () {
      return {
        hasEntries: false
      }
    },
    methods: {
      save () {
        this.$emit('save')
      }
    },
    computed: {
      getStyle () {
        if (this.hasEntries && this.item.step === 1) {
          return {}
        }

        if (this.item.step === 1 && this.item.getDropzone() && this.item.getDropzone().files.length >= 3) {
          return {}
        }

        if (this.item.step === 3) {
          return {}
        }

        return { display: 'none' }
      },
      hasFileConfiguration () {
        return _.keys(this.item.fileConfiguration).length > 0
      }
    }
  }
</script>

<style scoped>

</style>
